import Button from "react-bootstrap/Button";
import "./submitButton.css";

export function SubmitButton() {
  return <Button type="submit" className="submitButton">Send</Button>;
}
